module.exports = __webpack_public_path__ + "img/link-mapPin.c1a6c52c.png";